import { render, staticRenderFns } from "./update_page.vue?vue&type=template&id=8b85e508&scoped=true&"
import script from "./update_page.vue?vue&type=script&lang=js&"
export * from "./update_page.vue?vue&type=script&lang=js&"
import style0 from "./update_page.vue?vue&type=style&index=0&id=8b85e508&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b85e508",
  null
  
)

export default component.exports